import Vue from 'vue';
export default Vue.extend({
    name: 'setOptimalLeveragesPopupChunk',
    data: () => ({
        showNoMore: false
    }),
    props: {
        slotData: {
            required: true
        }
    },
    watch: {
        showNoMore() {
            localStorage.setItem('showNoMoreOptimalLeverage', this.showNoMore);
        }
    }
});
